/* eslint-disable */
import React from 'react';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { CircularProgress } from '@mui/material';

type Status = 'must-agree' | 'has-agreed' | 'error';

const MobileDocusignBaa: React.FC<any> = () => {
  // notify the mobile app
  const sendToReactNative = (data: { message: string; status: Status }) => {
    try {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(data));
    } catch {}
  };

  const displayDocusignPopup = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');
    const fullName = urlParams.get('fullName');
    const practiceName = urlParams.get('practiceName');
    const state = urlParams.get('state');

    if (!email || !fullName || !practiceName) {
      sendToReactNative({
        status: 'error',
        message: 'The params are invalid.',
      });
      return;
    }

    try {
      const date = new Date();
      const dayNumber = format(date, 'do');
      const monthName = format(date, 'LLLL');
      const year = format(date, 'yyyy');
      const formattedDate = `${dayNumber} day of ${monthName}, ${year}`;

      (window as any).docuSignClick.Clickwrap.render(
        {
          environment: 'https://na4.docusign.net',
          accountId: '7d01337c-13ee-40fa-a316-db535eb10b2c',
          clickwrapId: '1b76dfb1-c4f9-4672-a5be-28a2ebb2c6d3',
          clientUserId: email,
          documentData: {
            date: formattedDate,
            email: email ?? '',
            fullName: fullName ?? '',
            title: practiceName ?? '',
            company: state ?? '',
          },
          onMustAgree: function () {
            sendToReactNative({
              status: 'must-agree',
              message: 'The user must agree with the BAA.',
            });
          },
          onAgreed: function () {
            sendToReactNative({
              status: 'has-agreed',
              message: 'The BAA has been agreed successfully.',
            });
          },
        },
        '#docusign-clickwrap-business-associate-agreement'
      );
    } catch (e) {
      sendToReactNative({
        status: 'error',
        message: 'There has been an error triggering ClickWrap.',
      });
    }
  };

  useEffect(displayDocusignPopup, []);

  return (
    <>
      <CircularProgress color='secondary' size='64px' />
      <div id='docusign-clickwrap-business-associate-agreement' />
    </>
  );
};

export default MobileDocusignBaa;
